import { render, staticRenderFns } from "./delivery-records.vue?vue&type=template&id=b3f2adec&scoped=true&"
import script from "./delivery-records.vue?vue&type=script&lang=js&"
export * from "./delivery-records.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f2adec",
  null
  
)

export default component.exports